module.exports = __webpack_public_path__ + "static/media/complete-rescheduling-background.5d7cd7ab.png";